{
  "files.title": "Dosyalar",
  "files.description": "Güvenli dosyaları bu kayda ekleyin ve revizyon geçmişini kaybetmeden yaşam döngülerini yönetin.",
  "files.expand": "Dosyaları göster",
  "files.collapse": "Dosyaları gizle",
  "files.add": "Dosya ekle",
  "files.quota": "Depolama kotası",
  "files.quota_value": "{{limit}} kotanın {{used}} kadarı kullanılıyor",
  "files.quota_detail": "{{available}} kullanılabilir · devam eden yüklemeler için {{reserved}} ayrıldı",
  "files.quota_error": "Depolama kotası yüklenemedi.",
  "files.show_trash": "Çöp Kutusu'ndaki dosyaları dahil et",
  "files.load_error": "Dosyalar yüklenemedi",
  "files.empty": "Ekli dosya yok",
  "files.empty_description": "Bu kayıtla birlikte tutmak için belge, görsel veya başka bir destek dosyası ekleyin.",
  "files.trash_empty": "Çöp Kutusu boş",
  "files.trash_empty_description": "Çöpe alınan ekler kalıcı silme tarihlerine kadar burada görünür.",
  "files.status.trashed": "Çöp Kutusu'nda",
  "files.download": "İndir",
  "files.download_error": "Dosya indirilemedi",
  "files.edit": "Düzenle",
  "files.trash": "Çöp Kutusu'na taşı",
  "files.restore": "Geri yükle",
  "files.purge": "Kalıcı sil",
  "files.trashed": "Dosya Çöp Kutusu'na taşındı",
  "files.restored": "Dosya geri yüklendi",
  "files.purged": "Dosya kalıcı olarak silindi",
  "files.purge_after": "{{date}} tarihinden sonra silinmek üzere planlandı",
  "files.trash_confirm_title": "Bu dosya Çöp Kutusu'na taşınsın mı?",
  "files.trash_confirm_description": "{{name}} kalıcı olarak silinene kadar geri yüklenebilir.",
  "files.purge_title": "Bu dosya kalıcı olarak silinsin mi?",
  "files.purge_description": "{{name}} ve depolanan baytları kaldırılacak. Bu işlem geri alınamaz.",
  "files.purge_confirmation": "Onay",
  "files.purge_confirmation_hint": "Devam etmek için tam olarak DELETE yazın.",
  "files.upload_title": "Dosya ekle",
  "files.upload_description": "Dosya güvenli ve ayrı adımlarda rezerve edilir, denetlenir, yüklenir ve kayda eklenir.",
  "files.select": "Dosya seç",
  "files.caption": "Açıklama",
  "files.upload": "Yükle ve ekle",
  "files.upload_progress": "Dosya hazırlanıyor ve denetleniyor",
  "files.upload_success": "Dosya eklendi",
  "files.upload_error": "Dosya eklenemedi",
  "files.over_quota": "Bu dosya şu an kullanılabilir olan {{available}} alandan daha büyük.",
  "files.policy_error": "Etkin eklentinin dosya kuralları yüklenemedi. Yükleme kullanılamıyor.",
  "files.policy_limit": "Bu kayıt etkin eklentinin ek sınırına ulaştı.",
  "files.policy_rejected": "Bu dosya etkin eklentinin yükleme kurallarına uymuyor.",
  "files.policy_summary": "{{types}} · en fazla {{size}} · kayıt başına {{count}}",
  "files.edit_title": "Dosya bilgilerini düzenle",
  "files.name": "Görünen ad",
  "files.save": "Kaydet",
  "files.saved": "Dosya bilgileri kaydedildi",
  "files.cancel": "Vazgeç",
  "files.action_error": "Dosya işlemi tamamlanamadı",
  "files.action_error_description": "Dosya listesini yeniledikten sonra yeniden deneyin.",
  "files.size": "{{value}} {{unit}}",
  "files.unit.b": "B",
  "files.unit.kb": "KB",
  "files.unit.mb": "MB",
  "files.unit.gb": "GB",
  "files.unit.tb": "TB",

  "reminders.title": "Hatırlatıcı kuralları",
  "reminders.description": "Kayıtlarınızdaki kalıcı hatırlatıcıları oluşturun, güncelleyin, arşivleyin ve denetleyin.",
  "reminders.source_description": "{{source}} kaynağına bağlı kurallar.",
  "reminders.add": "Hatırlatıcı ekle",
  "reminders.show_archived": "Arşivlenmiş kuralları dahil et",
  "reminders.refresh": "Yenile",
  "reminders.load_error": "Hatırlatıcı kuralları yüklenemedi",
  "reminders.empty": "Hatırlatıcı kuralı yok",
  "reminders.empty_description": "Önemli bir anı kalıcı bir oluşuma dönüştürmek için kural oluşturun.",
  "reminders.enabled": "Etkin",
  "reminders.disabled": "Devre dışı",
  "reminders.archived_badge": "Arşivlendi",
  "reminders.edit": "Düzenle",
  "reminders.history": "Geçmiş",
  "reminders.materialize": "Oluşumları yenile",
  "reminders.materialized": "{{count}} oluşum kullanıma hazır",
  "reminders.materialize_offset_title": "Bu fark hangi kaynak saatini kullansın?",
  "reminders.materialize_offset_description": "Fark tetikleyicili hatırlatıcıların güvenle üretilebilmesi için kaynak etkinliğin güncel saati gerekir.",
  "reminders.materialize_source_at": "Kaynak tarihi ve saati",
  "reminders.materialize_source_at_hint": "Ayarlanan {{minutes}} dakikalık fark bu ana eklenir.",
  "reminders.archive": "Arşivle",
  "reminders.restore": "Geri yükle",
  "reminders.archived": "Hatırlatıcı kuralı arşivlendi",
  "reminders.restored": "Hatırlatıcı kuralı geri yüklendi",
  "reminders.archive_title": "Bu hatırlatıcı kuralı arşivlensin mi?",
  "reminders.archive_description": "{{title}} artık yeni oluşum üretmeyecek. Geçmişi erişilebilir kalacak.",
  "reminders.delivery_summary": "{{timezone}} · {{channels}} · Sessiz saatler: {{quiet}}",
  "reminders.source_summary": "Kaynak: {{type}} · {{id}}",
  "reminders.occurrences_title": "Oluşumlar",
  "reminders.occurrences_description": "Ertelenmiş ve çözülmüş öğeler dahil, önümüzdeki 90 günün planlanan teslimat gerçeği.",
  "reminders.occurrences_error": "Hatırlatıcı oluşumları yüklenemedi",
  "reminders.occurrences_empty": "Bu aralıkta oluşum yok",
  "reminders.occurrences_empty_description": "Yaklaşan oluşumları üretmek için bir kural oluşturun veya yenileyin.",
  "reminders.occurrence_updated": "Hatırlatıcı oluşumu güncellendi",
  "reminders.ack": "Tamamlandı",
  "reminders.snooze": "10 dk ertele",
  "reminders.cancel_occurrence": "Oluşumu iptal et",
  "reminders.create_title": "Hatırlatıcı kuralı oluştur",
  "reminders.edit_title": "Hatırlatıcı kuralını düzenle",
  "reminders.editor_description": "Saatler seçilen IANA saat dilimini kullanır. Revizyonlar başka bir cihazdaki değişikliklerin üzerine yazılmasını önler.",
  "reminders.source_type": "Kaynak türü",
  "reminders.source_id": "Kaynak kayıt kimliği",
  "reminders.source_id_hint": "Bu hatırlatıcının sahibi olan kaydın UUID değerini kullanın.",
  "reminders.source_revision": "Kaynak revizyonu",
  "reminders.rule_title": "Hatırlatıcı başlığı",
  "reminders.body": "Mesaj",
  "reminders.trigger_type": "Tetikleyici",
  "reminders.trigger.absolute": "Belirli tarih ve saat",
  "reminders.trigger.offset": "Kaynak saatine göre fark",
  "reminders.trigger.recurrence": "Tekrarlanan plan",
  "reminders.absolute_at": "Tarih ve saat",
  "reminders.offset_minutes": "Dakika farkı",
  "reminders.offset_hint": "Kaynak saatinden önce için negatif, aynı an için sıfır, sonrası için pozitif sayı kullanın.",
  "reminders.frequency": "Sıklık",
  "reminders.frequency.daily": "Günlük",
  "reminders.frequency.weekly": "Haftalık",
  "reminders.recurrence_time": "Yerel saat",
  "reminders.start_date": "Başlangıç tarihi",
  "reminders.end_date": "Bitiş tarihi (isteğe bağlı)",
  "reminders.weekdays": "Haftanın günleri",
  "reminders.weekday.1": "Pzt",
  "reminders.weekday.2": "Sal",
  "reminders.weekday.3": "Çar",
  "reminders.weekday.4": "Per",
  "reminders.weekday.5": "Cum",
  "reminders.weekday.6": "Cmt",
  "reminders.weekday.7": "Paz",
  "reminders.timezone": "Saat dilimi",
  "reminders.timezone_hint": "Europe/Istanbul gibi bir IANA adı kullanın.",
  "reminders.channels": "Teslimat kanalları",
  "reminders.channel.in_app": "Uygulama içi gelen kutusu",
  "reminders.channel.web_push": "Tarayıcı bildirimi",
  "reminders.web_push_hint": "Tarayıcı izni ve etkin bir bildirim aboneliği de gerekir.",
  "reminders.quiet_behavior": "Sessiz saatlerde",
  "reminders.quiet_hint": "Bu kural hesabın sessiz saatler aralığına uyar.",
  "reminders.quiet.delay": "Sessiz saatler bitene kadar ertele",
  "reminders.quiet.suppress": "Oluşumu bastır",
  "reminders.quiet.deliver": "Yine de teslim et",
  "reminders.enabled_label": "Kural etkin",
  "reminders.dst_note": "Tekrarlanan saatler bu saat dilimine bağlı kalır. Yaz saati geçişlerinde sunucu eksik veya yinelenen yerel saatleri tutarlı biçimde çözer ve özgün planlanan anı geçmişte saklar.",
  "reminders.cancel": "Vazgeç",
  "reminders.create": "Kural oluştur",
  "reminders.save": "Değişiklikleri kaydet",
  "reminders.created": "Hatırlatıcı kuralı oluşturuldu",
  "reminders.saved": "Hatırlatıcı kuralı kaydedildi",
  "reminders.history_title": "Hatırlatıcı geçmişi",
  "reminders.history_error": "Hatırlatıcı geçmişi yüklenemedi",
  "reminders.history_empty": "Kayıtlı revizyon yok",
  "reminders.close": "Kapat",
  "reminders.revision": "Revizyon {{revision}}",
  "reminders.untitled": "Başlıksız hatırlatıcı",
  "reminders.offset_summary": "Kaynak saatinden {{minutes}} dakika önce",
  "reminders.offset_before": "Kaynak saatinden {{minutes}} dakika önce",
  "reminders.offset_after": "Kaynak saatinden {{minutes}} dakika sonra",
  "reminders.offset_at_source": "Kaynak saatiyle aynı anda",
  "reminders.recurrence_summary": "{{frequency}} {{time}} {{days}}",
  "reminders.action_error": "Hatırlatıcı işlemi tamamlanamadı",
  "reminders.action_error_description": "Kuralı yenileyip yeniden deneyin.",
  "reminders.validation.source": "Geçerli bir kaynak kayıt UUID değeri girin.",
  "reminders.validation.title": "Bir hatırlatıcı başlığı girin.",
  "reminders.validation.revision": "Kaynak revizyonu 1 veya daha büyük bir tam sayı olmalıdır.",
  "reminders.validation.timezone": "Geçerli bir IANA saat dilimi girin.",
  "reminders.validation.channel": "En az bir teslimat kanalı seçin.",
  "reminders.validation.absolute": "Geçerli bir tarih ve saat seçin.",
  "reminders.validation.offset": "-525600 ile 525600 dakika arasında bir fark girin.",
  "reminders.validation.recurrence": "Geçerli bir başlangıç tarihi ve yerel saat seçin.",
  "reminders.validation.weekdays": "En az bir gün seçin.",
  "reminders.validation.end_date": "Bitiş tarihi başlangıç tarihinden önce olamaz.",
  "reminders.source.task": "Görev",
  "reminders.source.routine": "Rutin",
  "reminders.source.project": "Proje",
  "reminders.source.plan": "Plan",
  "reminders.source.note": "Not",
  "reminders.source.knowledge_item": "Bilgi öğesi",
  "reminders.source.life_item": "Yaşam kaydı",
  "reminders.state.planned": "Planlandı",
  "reminders.state.due": "Zamanı geldi",
  "reminders.state.snoozed": "Ertelendi",
  "reminders.state.acknowledged": "Tamamlandı",
  "reminders.state.cancelled": "İptal edildi",
  "reminders.state.suppressed": "Bastırıldı",
  "reminders.manage_title": "Tüm hatırlatıcı kurallarını yönet",
  "reminders.manage_description": "Planları, oluşumları, arşivleri ve revizyon geçmişini tek yerde inceleyin.",
  "reminders.manage": "Hatırlatıcı yöneticisini aç",

  "backup.browser_title": "Yedek geri yükleme tarayıcıda devam eder",
  "backup.browser_description": "Arşiv dışa aktarma ve yerine koyarak geri yükleme, tarayıcı akışı ile birinci taraf oturum denetimlerini kullanır. Yerel çevrimdışı veriler aşağıda kullanılabilir kalır.",
  "backup.continue_browser": "Tarayıcıda devam et",
  "backup.export_v11": "İmzalı arşivi dışa aktar",
  "backup.export_legacy": "Eski JSON'u dışa aktar",
  "backup.export_description": "İmzalı V11 arşivi eksiksiz ve bütünlüğü denetlenen yedektir. Eski istemciler için JSON dışa aktarma ve geri yükleme desteği sürer.",
  "backup.format_v11": "İmzalı V{{version}} arşivi",
  "backup.format_legacy": "Eski web yedeği",
  "backup.integrity_verified": "Bütünlük doğrulandı",
  "backup.integrity_failed": "Bütünlük doğrulanmadı",
  "backup.signature_verified": "İmza doğrulandı",
  "backup.signature_failed": "İmza doğrulanmadı",
  "backup.legacy_warning": "Eski yedek: yalnızca uyumluluk denetimleri var; arşiv imzası bulunmuyor.",
  "backup.confirm_label": "Yerine koyma onayı",
  "backup.confirm_hint": "Tam olarak REPLACE yazın. Doğrulanmış önizleme yeniden denetlendikten sonra mevcut sunucu verileri değiştirilecek.",

  "calendar.portability.title": "Takvim taşınabilirliği",
  "calendar.portability.description": "Bu görünümü dışa aktarın, iCalendar içe aktarımlarını önizleyin ve iptal edilebilir abonelik akışlarını yönetin.",
  "calendar.portability.expand": "Taşınabilirlik araçlarını aç",
  "calendar.portability.collapse": "Taşınabilirlik araçlarını gizle",
  "calendar.export.title": "Bu takvim görünümünü dışa aktar",
  "calendar.export.description": "{{from}} ile {{to}} arasındaki planlanmış öğeleri standart .ics dosyası olarak indirin.",
  "calendar.export.name": "Takvim adı",
  "calendar.export.action": ".ics dışa aktar",
  "calendar.export.success": "Takvim dışa aktarıldı",
  "calendar.import.title": "iCalendar içe aktar",
  "calendar.import.description": "Hiçbir şey yazılmadan önce her oluşturma, güncelleme, kopya, çakışma ve desteklenmeyen tekrarı önizleyin.",
  "calendar.import.file": "iCalendar dosyası seç",
  "calendar.import.project": "Hedef proje",
  "calendar.import.project_hint": "İçe aktarılan görevler kişisel kalabilir veya tek bir projeye atanabilir.",
  "calendar.import.unassigned": "Kişisel takvim (projesiz)",
  "calendar.import.preview": "İçe aktarmayı önizle",
  "calendar.import.preview_error": "Takvim önizlenemedi",
  "calendar.import.file_too_large": "2 MB'den küçük bir iCalendar dosyası seçin.",
  "calendar.import.creates": "{{count}} yeni",
  "calendar.import.updates": "{{count}} güncelleme",
  "calendar.import.duplicates": "{{count}} kopya",
  "calendar.import.conflicts": "{{count}} çakışma",
  "calendar.import.unsupported": "{{count}} desteklenmiyor",
  "calendar.import.expires": "Önizleme {{date}} tarihinde sona erer",
  "calendar.import.apply_updates": "Daha önce içe aktarılan etkinliklere güvenli güncellemeleri uygula",
  "calendar.import.apply_updates_hint": "Yerel bir düzenlemenin sessizce üzerine yazılmaması için varsayılan olarak kapalıdır.",
  "calendar.import.bind_duplicates": "Yeni görev oluşturmadan tam kopyaları bağla",
  "calendar.import.bind_duplicates_hint": "Mevcut kaydı korurken sonraki içe aktarımları tekrarlanabilir tutar.",
  "calendar.import.apply": "İncelenen içe aktarmayı uygula",
  "calendar.import.confirm_title": "Bu takvim içe aktarımı uygulansın mı?",
  "calendar.import.confirm_description": "{{creates}} kayıt oluşturulacak ve incelenen {{updates}} güncelleme uygulanacak. Çakışmalar atlanır.",
  "calendar.import.success": "Takvim içe aktarımı uygulandı",
  "calendar.import.success_detail": "{{created}} oluşturuldu · {{updated}} güncellendi · {{skipped}} atlandı",
  "calendar.import.disposition.create": "Oluştur",
  "calendar.import.disposition.update": "Güncelle",
  "calendar.import.disposition.duplicate": "Kopya",
  "calendar.import.disposition.conflict": "Çakışma",
  "calendar.import.disposition.unsupported_recurrence": "Desteklenmeyen tekrar",
  "calendar.subscriptions.title": "Abonelik akışları",
  "calendar.subscriptions.description": "Takvim uygulamaları için salt okunur taşıyıcı bağlantılar oluşturun. Açığa çıkan bağlantıyı döndürün veya hemen iptal edin.",
  "calendar.subscriptions.add": "Yeni akış",
  "calendar.subscriptions.error": "Abonelik akışları yüklenemedi",
  "calendar.subscriptions.empty": "Abonelik akışı yok",
  "calendar.subscriptions.empty_description": "Başka bir takvim uygulamasından abone olmak için akış oluşturun.",
  "calendar.subscriptions.active": "Etkin",
  "calendar.subscriptions.revoked_badge": "İptal edildi",
  "calendar.subscriptions.secret_hint": "Gizli anahtar {{hint}} ile bitiyor",
  "calendar.subscriptions.rotated": "{{date}} tarihinde döndürüldü",
  "calendar.subscriptions.edit": "Düzenle",
  "calendar.subscriptions.rotate": "Bağlantıyı döndür",
  "calendar.subscriptions.revoke": "İptal et",
  "calendar.subscriptions.rotate_title": "Bu abonelik bağlantısı döndürülsün mü?",
  "calendar.subscriptions.rotate_description": "Mevcut taşıyıcı bağlantı hemen çalışmayı bırakacak. Yeni bağlantı yalnızca bir kez gösterilecek.",
  "calendar.subscriptions.revoke_title": "Bu abonelik akışı iptal edilsin mi?",
  "calendar.subscriptions.revoke_description": "Abone uygulamalar güncellemeleri hemen almayı bırakacak. İptal geri alınamaz.",
  "calendar.subscriptions.revoked": "Abonelik akışı iptal edildi",
  "calendar.subscriptions.create_title": "Abonelik akışı oluştur",
  "calendar.subscriptions.edit_title": "Abonelik akışını düzenle",
  "calendar.subscriptions.editor_description": "Sınırlı, kayan bir takvim görünümü seçin. Akış içeriğini sunucu üretir; gizli anahtar yalnızca bir kez gösterilir.",
  "calendar.subscriptions.name": "Akış adı",
  "calendar.subscriptions.project": "Proje filtresi",
  "calendar.subscriptions.project_hint": "Proje takvimlerinden istediğiniz birleşimi ve aşağıdaki kişisel takvimi seçin.",
  "calendar.subscriptions.all_projects": "Tüm proje takvimleri",
  "calendar.subscriptions.include_unassigned": "Kişisel, projesiz öğeleri dahil et",
  "calendar.subscriptions.window_hint": "Akış, seçili saat diliminde önceki 30 gün ile yaklaşan 365 günü içerir.",
  "calendar.subscriptions.saved": "Abonelik akışı kaydedildi",
  "calendar.subscriptions.created": "Abonelik akışı oluşturuldu",
  "calendar.subscriptions.secret_title": "Bu abonelik bağlantısını şimdi kaydedin",
  "calendar.subscriptions.secret_description": "Güvenlik için tam taşıyıcı gizli anahtarı yeniden gösterilmeyecek.",
  "calendar.subscriptions.copy": "Akış bağlantısını kopyala",
  "calendar.subscriptions.copied": "Akış bağlantısı kopyalandı",
  "calendar.subscriptions.copy_error": "Akış bağlantısı kopyalanamadı",
  "calendar.subscriptions.secret_warning": "Bu bağlantıya sahip herkes seçili takvimi okuyabilir. Açığa çıkarsa bağlantıyı döndürün.",
  "calendar.subscriptions.secret_done": "Bağlantıyı kaydettim",
  "calendar.cancel": "Vazgeç",
  "calendar.save": "Kaydet",
  "calendar.create": "Akış oluştur",
  "calendar.action_error": "Takvim işlemi tamamlanamadı",
  "calendar.action_error_description": "Takvim verilerini yenileyip yeniden deneyin.",
  "settings.identity_hub.title": "Profiliniz ve asistan erişimi",
  "settings.identity_hub.description": "Exognitos'un sizi anlamak için kullandığı bilgileri gözden geçirin ve tüm asistan bağlantılarını tek yerden yönetin.",
  "settings.identity_hub.profile": "Profili aç",
  "settings.identity_hub.connections": "Asistan bağlantıları",
  "settings.identity_hub.memory": "Asistan hafızası"
}
